import { useState, useEffect } from "react";

import { Event, Sport } from "@gp/models";

const sportsWithIndicatedScore = ["soccer", "handball", "basketball"];
const notStarted = "not-started";

export function useLiveMatchResult(
	event: Event,
	sport: Sport,
	options: { scoreChangeDuration?: number | undefined }
) {
	const [isScore, setIsScore] = useState(false);
	const [timeOutId, setTimeoutId] = useState<number | undefined>(undefined);

	useEffect(() => {
		if (
			!sportsWithIndicatedScore.includes(sport.abrv) ||
			event.currentScore == null
		) {
			return;
		}

		setIsScore(true);

		timeOutId != null && clearTimeout(timeOutId);

		const newTimeOutId = window.setTimeout(() => {
			if (timeOutId == null) return;
			setIsScore(false);
			setTimeoutId(undefined);
		}, options.scoreChangeDuration);

		setTimeoutId(newTimeOutId);

		return () => {
			if (timeOutId != null) {
				clearTimeout(timeOutId);
				setTimeoutId(undefined);
			}
		};
	}, [event.currentScore?.home, event.currentScore?.away]);

	const getScore = (team: "home" | "away") => {
		if (event.matchStatus === notStarted) {
			return "-";
		}

		if (sport.abrv == "cricket") {
			if (event?.result) {
				if (event.result.scorePerPeriod.length > 1) {
					return `${event.result.scorePerPeriod[0][team] || 0}/${event.result.scorePerPeriod[1][team] || 0}`;
				} else {
					return event.result.scorePerPeriod[0][team] || 0;
				}
			} else {
				return 0;
			}
		}

		if (event.currentScore != null) {
			return event.currentScore[team] || 0;
		}

		return 0;
	};

	return {
		isScore,
		home: getScore("home"),
		away: getScore("away"),
	};
}
